import { useTable, useRowSelect, usePagination } from "react-table";
import styled from "styled-components";
import { TitleText } from "./Text";
import { DeleteIcon } from "../assets/svg/DeleteIcon";
import SearchInput from "./SearchInput";
import { DropDown } from "./DropDown";
import { Formik, Field } from "formik";
import { get } from "../utils/get";
import { useLocation } from "react-router-dom";
import { Button } from "./Button";
import { DropDownIcon } from "../assets/svg/DropDownIcon";
import React, { useState, useEffect, useRef } from "react";
import { PreviewSubject } from "../subjects/PreviewSubject";

interface TableProps {
  columns: any;
  data: any;
  setModal?: any;
  setScorecard?: any;
  setPIP?: any;
  periods?: any;
  owners?: any;
  organisations?: any;
  setFilter?: any;
  filter?: any;
  status?: any;
  title?: any;
  isReviewDept?: any;
  isScorecard?: boolean;
  pageCount?: any;
  handlePagination?: any;
  handleSearch?: any;
  dataSize?: any;
  isOrganisationType?: any;
  isOrganisation?: boolean;
  orgTypes?: any;
  companies?: any;
  roles?: any;
  scorecardType?:any[];
}

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }: any, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef: any = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <Checkbox type="checkbox" ref={resolvedRef} {...rest} />
        <span></span>
      </>
    );
  }
);

const Table = ({
  columns,
  data,
  setModal,
  setScorecard,
  owners,
  organisations,
  periods,
  scorecardType,
  setFilter,
  status,
  title,
  filter,
  isScorecard,
  isOrganisationType,
  isOrganisation,
  isReviewDept,
  handlePagination,
  handleSearch,
  dataSize,
  orgTypes,
  companies,
  roles,
  pageCount: controlledPageCount,
}: TableProps) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { selectedRowIds, pageIndex, pageSize },
  }: any = useTable(
    {
      columns,
      data,
      //@ts-ignore
      initialState: { pageIndex: 0 },
      manualPagination: controlledPageCount ? true : false,
      pageCount: controlledPageCount,
    },
    usePagination,
    useRowSelect,
    (hooks) => {}
  );
  const location = useLocation();

  React.useEffect(() => {
    if (handlePagination) {
      handlePagination({ pageIndex, pageSize });
    }
  }, [handlePagination, pageIndex, pageSize]);

  const [visible, setVisibility] = useState(true);
  const [referenceElement, setReferenceElement] = useState<any>(null);
  const [popperElement, setPopperElement] = useState<any>(null);
  const [arrowElement, setArrowElement] = useState<any>(null);
  // const { styles, attributes } = usePopper(referenceElement, popperElement, {
  //   modifiers: [{ name: "arrow", options: { element: arrowElement } }],
  // });

  function handleDropdownClick(event) {
    console.log(visible);
    setVisibility(!visible);
  }

  return (
    <Container>
      <ActionsContainer>
        <Section>
          {/* <SearchInput /> */}
          {setFilter ? (
            <Formik
              initialValues={{
                owner: "",
                period: "",
                manager: "",
              }}
              onSubmit={() => console.log("yeees")}
            >
              {({ values }) => (
                <>
                  {!isOrganisation &&
                    !isScorecard &&
                    !isOrganisationType &&
                    !isReviewDept && (
                      <>
                        <SearchInput handleChange={handleSearch} />

                        <span>
                          <Field
                            name="company"
                            placeholder="filter by company"
                            component={DropDown}
                            isBordered={true}
                            options={companies}
                            onChange={(e) => {
                              e
                                ? setFilter({
                                    ...filter,
                                    company: `company_id=${get(e, "value")}`,
                                  })
                                : setFilter({ ...filter, company: "" });
                            }}
                            width="12rem"
                            value={get(values, "company")}
                          />
                        </span>
                        <Field
                          name="organisation"
                          placeholder="filter by organisation"
                          component={DropDown}
                          isBordered={true}
                          options={organisations}
                          onChange={(e) => {
                            e
                              ? setFilter({
                                  ...filter,
                                  organisation: `organisation_id=${get(
                                    e,
                                    "value"
                                  )}`,
                                  organisation_id: `${get(e, "value")}`,
                                })
                              : setFilter({ ...filter, organisation: "" });
                          }}
                          width="12rem"
                          value={get(values, "organisation")}
                        />
                      </>
                    )}

                  {isOrganisation && (
                    <>
                      <SearchInput handleChange={handleSearch} />
                      <span>
                        <Field
                          name="company"
                          placeholder="filter by company"
                          component={DropDown}
                          isBordered={true}
                          options={companies}
                          onChange={(e) => {
                            e
                              ? setFilter({
                                  ...filter,
                                  company: `company_id=${get(e, "value")}`,
                                })
                              : setFilter({ ...filter, company: "" });
                          }}
                          width="9rem"
                          value={get(values, "compnay")}
                        />
                      </span>
                      <Field
                        name="orgType"
                        placeholder="filter by type"
                        component={DropDown}
                        isBordered={true}
                        options={orgTypes}
                        onChange={(e) => {
                          e
                            ? setFilter({
                                ...filter,
                                orgType: `organisation_type_id=${get(
                                  e,
                                  "value"
                                )}`,
                              })
                            : setFilter({ ...filter, orgType: "" });
                        }}
                        width="9rem"
                        value={get(values, "orgType")}
                      />{" "}
                      <span>
                        <Field
                          name="manager"
                          placeholder="filter by manager"
                          component={DropDown}
                          isBordered={true}
                          options={owners}
                          onChange={(e) => {
                            e
                              ? setFilter({
                                  ...filter,
                                  manager: `manager_id=${get(e, "value")}`,
                                })
                              : setFilter({ ...filter, manager: "" });
                          }}
                          width="9rem"
                          value={get(values, "manager")}
                        />
                      </span>
                      <span>
                        <Field
                          name="parent"
                          placeholder="filter by parent "
                          component={DropDown}
                          isBordered={true}
                          style={{ paddingLeft: "1rem" }}
                          options={organisations}
                          onChange={(e) => {
                            e
                              ? setFilter({
                                  ...filter,
                                  parent: `parent_organisation_id=${get(
                                    e,
                                    "value"
                                  )}`,
                                })
                              : setFilter({ ...filter, parent: "" });
                          }}
                          width="9rem"
                          value={get(values, "parent")}
                        />{" "}
                      </span>
                    </>
                  )}
                  {isOrganisationType && (
                    <>
                      <SearchInput handleChange={handleSearch} />
                    </>
                  )}
                  {isScorecard && (
                    <>
                      {" "}
                      <span>
                        <Field
                          name="owner"
                          placeholder="filter by owner"
                          component={DropDown}
                          isBordered={true}
                          options={owners}
                          onChange={(e) => {
                            e
                              ? setFilter({
                                  ...filter,
                                  owner: `owner_id=${get(e, "value")}`,
                                })
                              : setFilter({ ...filter, owner: "" });
                          }}
                          width="9rem"
                          value={get(values, "owner")}
                        />
                      </span>
                      <Field
                        name="period"
                        placeholder="filter by period"
                        component={DropDown}
                        isBordered={true}
                        options={periods}
                        onChange={(e) => {
                          e
                            ? setFilter({
                                ...filter,
                                period: `period_id=${get(e, "value")}`,
                              })
                            : setFilter({ ...filter, period: "" });
                        }}
                        width="9rem"
                        value={get(values, "period")}
                      />{" "}
                      <span>
                        <Field
                          name="status"
                          placeholder="filter by status"
                          component={DropDown}
                          isBordered={true}
                          style={{ paddingLeft: "1rem" }}
                          options={[
                            { label: "Active", value: "active" },
                            { label: "Draft", value: "draft" },
                            { label: "Archive", value: "archived" },
                            {
                              label: "Pending Approval",
                              value: "pending-approval",
                            },
                          ]}
                          onChange={(e) => {
                            e
                              ? setFilter({
                                  ...filter,
                                  status: `include_status=${get(e, "value")}`,
                                })
                              : setFilter({ ...filter, status: "" });
                          }}
                          width="9rem"
                          value={get(values, "status")}
                        />{" "}
                      </span>
                      <span>
                        <Field
                          name="scorecard type"
                          placeholder="filter by scorecard type"
                          component={DropDown}
                          isBordered={true}
                          style={{ paddingLeft: "1rem" }}
                          options={[
                            { label: "PIP", value: "PIP" },
                            { label: "Regular", value: "Regular" },
                            { label: "Probation", value: "Probation" }
                          ]}
                          onChange={(e) => {
                            e
                              ? setFilter({
                                  ...filter,
                                  scorecardType: `scorecard_type=${get(e, "value")}`,
                                })
                              : setFilter({ ...filter, scorecardType: "" });
                          }}
                          width="10rem"
                          value={get(values, "scorecard_type")}
                        />{" "}
                      </span>
                    </>
                  )}
                </>
              )}
            </Formik>
          ) : null}
        </Section>
        {get(location, "pathname").includes("pending") ||
        get(location, "pathname").includes("archive") ? null : (
          <Section style={{ justifyContent: "flex-end" }}>
            <Button
              text={title || "Add new +"}
              onClick={() => setModal(true)}
            />
          </Section>
        )}
      </ActionsContainer>
      <StyledTable>
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  style={
                    row.isSelected
                      ? { backgroundColor: "#f7f8ff" }
                      : { backgroundColor: "#fff" }
                  }
                  {...row.getRowProps(
                    setScorecard
                      ? { onClick: () => setScorecard(row) }
                      : { onClick: () => console.log("clicked") }
                  )}
                >
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        <Footer>
          <Total>Total records: {dataSize ? dataSize : data.length}</Total>
          <Paginantion>
            <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
              {"<<"}
            </button>
            <button onClick={() => previousPage()} disabled={!canPreviousPage}>
              {"<"}
            </button>
            <button onClick={() => nextPage()} disabled={!canNextPage}>
              {">"}
            </button>
            <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </button>
            <span>
              Page
              <strong>
                {pageIndex + 1} of {pageOptions.length || 1}
              </strong>
            </span>
          </Paginantion>
        </Footer>
      </StyledTable>
    </Container>
  );
};

export default Table;

const Container = styled.div`
  display: grid;
  grid-template-rows: 3em auto;
`;

const StyledTable = styled.div`
  margin-top: 40px;
  padding-top: 2em;
  table {
    width: 100%;
    border-spacing: 0;
    padding: 2em;
    /* border: 1px solid black; */
    th {
      font-size: 14px;
      font-weight: bold;
      color: #214160;
      opacity: 1 !important;
      text-align: left;
    }
    tr {
      color: rgba(33, 65, 96, 0.5);
      font-size: 12px;
      &:hover {
        /* background-color: #f7f8ff; */
      }
      :last-child {
        td {
          border-bottom: 1px solid rgba(55, 81, 255, 0.1);
        }
      }

      td {
        :first-child {
          padding: 1rem 0;
          /* width: 2em; */
        }
        :nth-child(2) {
          font-size: 14px;
          font-weight: bold;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 1.5rem;
      border-bottom: 1px solid rgba(55, 81, 255, 0.1);
      :last-child {
        border-right: 0;
      }
      :first-child {
        padding: 2rem 0;
        /* width: 2em; */
      }
    }
  }
`;

const ActionsContainer = styled.div`
  display: grid;
  grid-template-columns: 4fr 0.5fr;
  padding: 2em;
`;
const Section = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    margin: 0 0.5em;
  }
`;

const Checkbox = styled.input`
  height: 16px;
  width: 16px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  border: 1px solid #e2e6f8;
  border-radius: 3px;
  outline: none;
  transition-duration: 0.3s;
  background-color: #fff;
  cursor: pointer;
  position: relative;
  &:checked {
    /* border: 1px solid #41b883; */
    background-color: #01a8ce;
  }

  &:active {
    /* border: 2px solid #; */
  }
`;

const Total = styled.div`
  display: flex;
  padding: 0.1em 4em;
  color: #214160;
`;

const Paginantion = styled.div`
  padding: 1em 2em;
  button {
    margin: 0.3em;
    font-weight: bolder;
    background-color: #fff;
    border: none;
    font-size: 1em;
    border-radius: 50%;
    height: 3em;
    width: 3em;
    padding: 1em;
    align-items: center;
    justify-content: center;
    &:hover {
      background-color: #d3d6fe;
    }
  }
  span {
    margin: 1em;
  }
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const MyDropDownItem = styled.span`
  display: flex;
  justify-content: flex-start;
  height: 40px;
  padding-right: 10px;
  padding-left: 10px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: #d3dbff;
  }
  &:active {
    font-weight: 700;
    color: #00ffff;
  }
`;

export const MyDropdownContainer = styled.div<{ visible: boolean }>`
  display: ${(props) => (props.visible ? "inline-block" : "none")};
  float:left;
  padding: 5px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.14);
  z-index: 1000;
 
`;
